import { IUserDepricated } from "@mctypes/global.types";
import { Box, Paper, Stack, Title, Flex } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "../../../hooks";
import { logicWhenAppStarts } from "../../actions";
import { doAcceptInvite, doGetUserByPassRequestCode, doLoginLocal } from "../../userApi";
import CreateAccount from "./CreateAccount/CreateAccount";

const AcceptInvite: React.FC<{ code: string; userId: string }> = ({ code, userId }) => {
  const [notValid, setNotValid] = React.useState<boolean>(false);
  const [user, setUser] = React.useState<IUserDepricated>(null);
  React.useEffect(() => {
    init();
  }, []);

  const history = useHistory();
  const dispatch = useAppDispatch();

  const init = async () => {
    const _user = await doGetUserByPassRequestCode(code, userId);
    if (_user?.email == null) {
      setNotValid(true);
    } else {
      if (_user.acceptedInvite === true) {
        history.push("/projects");
      } else {
        setUser(_user);
      }
    }
  };

  const createAccount = async (name: string, phoneNumber: string, password: string) => {
    await doAcceptInvite(code, userId, password, name, phoneNumber);
    await doLoginLocal(user.email, password);
    history.push("/projects");
    setTimeout(() => {
      dispatch(logicWhenAppStarts(history));
    }, 500);
  };

  return (
    <Flex>
      <Box flex={1} />
      {notValid === true && (
        <Paper withBorder p="sm" radius="sm" bg="#fdfdff" m="2rem" style={{ width: "500px" }}>
          <Stack gap="xs">
            <Title order={4} fw={400}>
              Opprett konto
            </Title>
            {notValid === true && (
              <>
                <p>Denne lenken er ikke lenger gyldig. Det kan være at du allerede har opprettet en konto.</p>
                <a href="/login">Gå til Login</a>
                <Box mt="lg">
                  Support: <br />
                  <a href="mailto:mcapps@multiconsult.no">mcapps@multiconsult.no</a>
                </Box>
              </>
            )}
          </Stack>
        </Paper>
      )}
      {notValid === false && (
        <Box mt="2rem" style={{ width: "300px" }}>
          <CreateAccount onCreateAccount={createAccount} />
        </Box>
      )}
      <Box flex={1} />
    </Flex>
  );
};

export default AcceptInvite;
